<div class="iq-sidebar">
  <div class="iq-sidebar-logo">
    <a routerLink="/dashboard">
      <div class="topsidelogo">
        <h1>All Out: Admin Panel</h1>
      </div>
    </a>
  </div>
  <div id="sidebar-scrollbar">
    <nav class="iq-sidebar-menu">
      <ul id="iq-sidebar-toggle" class="iq-menu" [class.extendHeight]="dataManagementMainMenu || 
      manageCustomersMainMenu || manageCustomersMainMenu || manageVendorsMainMenu || appManagementMainMenu">

        <li [ngClass]="{ 'active main-active': dashboard.isActive }">
          <a class="iq-waves-effect" routerLink="/dashboard" routerLinkActive #dashboard="routerLinkActive"
            [routerLinkActiveOptions]="{exact: true}">

            <i class="ri-hospital-fill"></i><span>Dashboard</span>

          </a>
        </li>

        <li [ngClass]="{ 'active main-active': bookings.isActive }">
          <a class="iq-waves-effect" routerLink="/bookings" routerLinkActive #bookings="routerLinkActive"
            [routerLinkActiveOptions]="{exact: true}">

            <i class="fa fa-calendar"></i>
            <span>Manage Booking</span>

          </a>
        </li>

        <li [ngClass]="{ 'active main-active': comboBooking.isActive }">
          <a class="iq-waves-effect" routerLink="/combo-booking" routerLinkActive #comboBooking="routerLinkActive"
            [routerLinkActiveOptions]="{exact: true}">

            <i class="fa fa-calendar"></i>
            <span>Manage Combo Booking</span>

          </a>
        </li>

        <li [ngClass]="{ 'active main-active': partnersLink.isActive }">
          <a class="iq-waves-effect" routerLink="/partners" routerLinkActive #partnersLink="routerLinkActive">

            <i class="fa fa-handshake-o"></i>
            <span>Partners</span>

          </a>
        </li>

        <li [ngClass]="{ 'active main-active': refundManagement.isActive }">
          <a class="iq-waves-effect" routerLink="/refund-management" routerLinkActive
            #refundManagement="routerLinkActive" [routerLinkActiveOptions]="{exact: true}">

            <i class="fa fa-calendar"></i>
            <span>Refund Management</span>

          </a>
        </li>

        <li [ngClass]="{ 'active main-active': leads.isActive }">
          <a class="iq-waves-effect" routerLink="/leads" routerLinkActive #leads="routerLinkActive"
            [routerLinkActiveOptions]="{exact: true}">

            <i class="fa fa-user-circle-o"></i>
            <span>Manage Leads</span>

          </a>
        </li>

        <li>

          <a href="#datamanagement" class="iq-waves-effect collapsed" data-toggle="collapse"
            [attr.aria-expanded]="dataManagementMainMenu">

            <i class="fa fa-hdd-o"></i>
            <span>Data Management</span>
            <i class="ri-arrow-right-s-line iq-arrow-right"></i>

          </a>

          <ul id="datamanagement" class="iq-submenu collapse" data-parent="#iq-sidebar-toggle"
            [ngClass]="{'show' : dataManagementMainMenu }">

            <li [ngClass]="{ 'active' : dmsm8.isActive }">
              <a routerLink="/manage/locations" routerLinkActive #dmsm8="routerLinkActive"
                [routerLinkActiveOptions]="{exact: true}">
                <i class="fa fa-hdd-o"></i><span>Manage Location</span>
              </a>
            </li>

            <li [ngClass]="{ 'active' : dmsm1.isActive }">
              <a routerLink="/manage/services" routerLinkActive #dmsm1="routerLinkActive"
                [routerLinkActiveOptions]="{exact: true}">
                <i class="fa fa-hdd-o"></i><span>Manage Service</span>
              </a>
            </li>

            <!-- <li [ngClass]="{ 'active' : dmsm2.isActive }">
              <a routerLink="/manage/plans" routerLinkActive #dmsm2="routerLinkActive"
              [routerLinkActiveOptions]="{exact: true}">
                <i class="fa fa-hdd-o"></i><span>Manage Plans</span>
              </a>
            </li> -->

            <li [ngClass]="{ 'active' : dmsm3.isActive }">
              <a routerLink="/manage/members" routerLinkActive #dmsm3="routerLinkActive"
                [routerLinkActiveOptions]="{exact: true}">
                <i class="fa fa-hdd-o"></i><span>Manage Members</span>
              </a>
            </li>

            <li [ngClass]="{ 'active' : dmsm4.isActive }">
              <a routerLink="/manage/banners" routerLinkActive #dmsm4="routerLinkActive"
                [routerLinkActiveOptions]="{exact: true}">
                <i class="fa fa-hdd-o"></i><span>Manage Banners</span>
              </a>
            </li>

            <li [ngClass]="{ 'active' : dmsm5.isActive }">
              <a routerLink="/manage/categories" routerLinkActive #dmsm5="routerLinkActive"
                [routerLinkActiveOptions]="{exact: true}">
                <i class="fa fa-hdd-o"></i><span>Manage Categories</span>
              </a>
            </li>

            <li [ngClass]="{ 'active' : dmsm5555.isActive }">
              <a routerLink="/manage/sub-categories" routerLinkActive #dmsm5555="routerLinkActive"
                [routerLinkActiveOptions]="{exact: true}">
                <i class="fa fa-hdd-o"></i><span>Manage Sub Categories</span>
              </a>
            </li>



            <li [ngClass]="{ 'active' : dmsm6.isActive }">
              <a routerLink="/manage/interests" routerLinkActive #dmsm6="routerLinkActive"
                [routerLinkActiveOptions]="{exact: true}">
                <i class="fa fa-hdd-o"></i><span>Manage Interests</span>
              </a>
            </li>

            <li [ngClass]="{ 'active' : dmsm7.isActive }">
              <a routerLink="/manage/cms" routerLinkActive #dmsm7="routerLinkActive"
                [routerLinkActiveOptions]="{exact: true}">
                <i class="fa fa-hdd-o"></i><span>Manage CMS</span>
              </a>
            </li>
            <li [ngClass]="{ 'active' : dmsm9.isActive }">
              <a routerLink="/manage/combo-packages" routerLinkActive #dmsm9="routerLinkActive"
                [routerLinkActiveOptions]="{exact: true}">
                <i class="fa fa-hdd-o"></i><span>Manage Combo Packages</span>
              </a>
            </li>
            <li [ngClass]="{ 'active main-active' : dmsm10.isActive }">
              <a routerLink="/manage/coupons" routerLinkActive #dmsm10="routerLinkActive"
                [routerLinkActiveOptions]="{exact: true}">
                <i class="fa fa-hdd-o"></i><span>Manage Coupons</span>
              </a>
            </li>
            <!-- <li [ngClass]="{ 'active' : dmsm11.isActive }">
              <a routerLink="/manage/admin-fees" routerLinkActive #dmsm11="routerLinkActive"
                [routerLinkActiveOptions]="{exact: true}">
                <i class="fa fa-hdd-o"></i><span>Admin Fees</span>
              </a>
            </li> -->
          </ul>
        </li>

        <li>

          <a href="#customers" class="iq-waves-effect collapsed" data-toggle="collapse"
            [attr.aria-expanded]="manageCustomersMainMenu">

            <i class="ri-user-3-fill"></i>
            <span>Manage Customers</span>
            <i class="ri-arrow-right-s-line iq-arrow-right"></i>

          </a>

          <ul id="customers" class="iq-submenu collapse" data-parent="#iq-sidebar-toggle"
            [ngClass]="{ 'show' : manageCustomersMainMenu }">

            <li [ngClass]="{ 'active' : mcsm1.isActive || this.updateCustomer }">
              <a routerLink="/customers" routerLinkActive #mcsm1="routerLinkActive"
                [routerLinkActiveOptions]="{exact: true}">
                <i class="ri-user-3-fill"></i><span>All Customers</span>
              </a>
            </li>

            <!-- <li [ngClass]="{ 'active' : mcsm2.isActive }">
              <a routerLink="customers/add" routerLinkActive #mcsm2="routerLinkActive"
              [routerLinkActiveOptions]="{exact: true}">
                <i class="fa fa-id-card-o"></i><span>Add Customers</span>
              </a>
            </li> -->

          </ul>
        </li>

        <li>
          <a href="#vendors" class="iq-waves-effect collapsed" data-toggle="collapse"
            [attr.aria-expanded]="manageVendorsMainMenu">

            <i class="ri-user-3-fill"></i>
            <span>Manage Vendors</span>
            <i class="ri-arrow-right-s-line iq-arrow-right"></i>

          </a>
          <ul id="vendors" class="iq-submenu collapse" data-parent="#iq-sidebar-toggle"
            [ngClass]="{ 'show' : manageVendorsMainMenu }">

            <li [ngClass]="{ 'active' : mvsm1.isActive || this.updateVendor }">
              <a routerLink="/vendors" routerLinkActive #mvsm1="routerLinkActive"
                [routerLinkActiveOptions]="{exact: true}">
                <i class="ri-user-3-fill"></i><span>All Vendors</span>
              </a>
            </li>

            <li [ngClass]="{ 'active' : mvsm2.isActive }">
              <a routerLink="vendors/add" routerLinkActive #mvsm2="routerLinkActive"
                [routerLinkActiveOptions]="{exact: true}">
                <i class="fa fa-id-card-o"></i><span>Add Vendor</span>
              </a>
            </li>
          </ul>
        </li>
          <li>

          <a href="#appManagement" class="iq-waves-effect collapsed" data-toggle="collapse"
            [attr.aria-expanded]="appManagementMainMenu">

            <i class="fa fa-hdd-o"></i>
            <span>App Management</span>
            <i class="ri-arrow-right-s-line iq-arrow-right"></i>

          </a>

          <ul id="appManagement" class="iq-submenu collapse" data-parent="#iq-sidebar-toggle"
            [ngClass]="{'show' : appManagementMainMenu }">

            <li [ngClass]="{ 'active' : appManage.isActive }">
              <a routerLink="/app-management/manage-color" routerLinkActive #appManage="routerLinkActive"
                [routerLinkActiveOptions]="{exact: true}">
                <i class="fa fa-hdd-o"></i><span>Manage Color</span>
              </a>
            </li>
            <li [ngClass]="{ 'active' : appWAConfig.isActive }">
              <a routerLink="/app-management/whatsapp-config" routerLinkActive #appWAConfig="routerLinkActive"
                [routerLinkActiveOptions]="{exact: true}">
                <i class="fa fa-hdd-o"></i><span>whatsapp Config</span>
              </a>
            </li>
          </ul>
        </li>

        <li [ngClass]="{ 'active main-active': complains.isActive }">
          <a routerLink="/complains" class="iq-waves-effect" routerLinkActive #complains="routerLinkActive"
            [routerLinkActiveOptions]="{exact: true}">

            <i class="fa fa-exclamation-circle"></i><span>Complaints</span>

          </a>
        </li>


        <li [ngClass]="{ 'active main-active': adminFee.isActive }">
          <a routerLink="/admin-fee" class="iq-waves-effect" routerLinkActive #adminFee="routerLinkActive"
            [routerLinkActiveOptions]="{exact: true}">

            <i class="fa fa-user-circle-o"></i><span>Admin Fee</span>

          </a>
        </li>

        <li>
          <a href="javascript:void(0);" class="iq-waves-effect" (click)="logout()">
            <i class="fa fa-sign-out"></i><span>Log Out</span>
          </a>
        </li>
      </ul>
    </nav>
    <div class="p-3"></div>
  </div>
</div>
